import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@mui/material';
import useDialogStyles from '../useDialogStyles';

export function ExitNewDialogContent({ savingDraft, close, saveDraft }) {
  const classes = useDialogStyles();

  return (
    <div>
      <h4 className={classes.dialogDescription}>Are you sure?</h4>
      <div className={classes.dialogButtonContainer}>
        <Button disableElevation className={classes.buttonSecondaryLight} onClick={close}>
          Cancel
        </Button>
        <Button
          disableElevation
          className={classes.buttonSecondary}
          onClick={saveDraft}
          style={{ minWidth: 130 }}
        >
          {savingDraft ? <CircularProgress size={20} color="inherit" /> : 'Save and exit'}
        </Button>
      </div>
    </div>
  );
}

ExitNewDialogContent.propTypes = {
  savingDraft: PropTypes.bool,
  close: PropTypes.func,
  saveDraft: PropTypes.func
};

export default ExitNewDialogContent;
